var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "ul",
      { staticClass: "list found-channels" },
      _vm._l(_vm.items, function (channel, i) {
        return _c(
          "li",
          [
            _c("channel-item", {
              attrs: {
                channel: channel,
                type: "search",
                focused: _vm.focusOnItem === i,
                noSelection: true,
              },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }